// OpenLayers image requests do not carry the application's Bearer header by default.
export function createAuthenticatedTileLoader() {
    const requests = new Map();

    function release(tile) {
        const pending = requests.get(tile);
        if (!pending) return;
        if (pending.timer) clearTimeout(pending.timer);
        if (pending.objectUrl) URL.revokeObjectURL(pending.objectUrl);
        pending.image.removeEventListener('load', pending.cleanup);
        pending.image.removeEventListener('error', pending.cleanup);
        requests.delete(tile);
    }

    function tileLoadFunction(tile, src) {
        const previous = requests.get(tile);
        if (previous) {
            previous.controller.abort();
            release(tile);
        }
        const image = tile.getImage();
        const controller = new AbortController();
        const pending = { controller, image, cleanup: () => release(tile) };
        requests.set(tile, pending);
        pending.timer = setTimeout(() => controller.abort(), 15000);
        let token;
        try {
            token = localStorage.getItem('jwt');
        } catch (error) {
            release(tile);
            tile.setState(3); // OpenLayers TileState.ERROR
            return;
        }
        if (!token) {
            release(tile);
            tile.setState(3);
            return;
        }
        fetch(src, {
            headers: { Authorization: `Bearer ${token}` },
            signal: controller.signal,
        }).then(response => {
            if (!response.ok || !(response.headers.get('Content-Type') || '').includes('image/png')) {
                throw new Error('A képréteg nem tölthető be.');
            }
            return response.blob();
        }).then(blob => {
            if (requests.get(tile) !== pending) return;
            pending.objectUrl = URL.createObjectURL(blob);
            image.addEventListener('load', pending.cleanup);
            image.addEventListener('error', pending.cleanup);
            image.src = pending.objectUrl;
        }).catch(() => {
            if (requests.get(tile) !== pending) return;
            release(tile);
            tile.setState(3);
        });
    }

    function dispose() {
        requests.forEach((pending, tile) => {
            pending.controller.abort();
            release(tile);
            tile.setState(3);
        });
    }

    return { tileLoadFunction, dispose };
}
